import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApiErrorMessage } from "utils/apiErrorMessage";
import { setUserContext } from "utils/sentryHelpers";

import { getAdvisorData } from "api/accounts";

interface AdvisorData {
  id?: string | number;
  email?: string;
  name?: string;
  organization_id?: string | number;
  membership?: {
    plan?: string;
    status?: string;
  };
  organization?: {
    type?: string;
    name?: string;
  };
  [key: string]: unknown;
}

export const loadAdvisorData = createAsyncThunk(
  "user/fetch",
  async (token, { rejectWithValue }) => {
    try {
      const data = (await getAdvisorData()) as AdvisorData;

      // Set Sentry user context with business tags when user data is loaded
      if (data) {
        setUserContext({
          id: data.id,
          email: data.email,
          username: data.name,
          organizationId: data.organization_id,
          membershipPlan: data.membership?.plan,
          organizationType: data.organization?.type,
        });
      }

      return data;
    } catch (error: unknown) {
      console.error("load user data error: ", error);
      // Siempre un string en el store: `data.message` puede ser el
      // diccionario de errores del serializer.
      return rejectWithValue(
        getApiErrorMessage(error, "No pudimos cargar tu información."),
      );
    }
  },
);
